import { Theme } from '@mui/material/styles';

import { makeStyles } from 'tss-react/mui';

export const useStyles = makeStyles<Theme>()((theme) => ({
  userWrapper: {
    [theme.breakpoints.down('md')]: {
      flexDirection: 'column',
      gap: theme.spacing(0.5),
      padding: theme.spacing(0.5),
      width: 'unset',
    },

    [theme.breakpoints.up('md')]: {
      // minHeight: '96px',
      padding: theme.spacing(1),
      gap: theme.spacing(1),
      display: 'flex',
      cursor: 'pointer',
      borderRadius: '10px',
      '&:hover': {
        backgroundColor: theme.palette.background.default,
      },
    },
  },

  avatarWrapper: {
    minWidth: '100px',
  },

  userDetails: {
    flex: '1',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    height: '100%',
  },
  infoWrapper: {
    display: 'flex',

    alignItems: 'center',
    flex: 1,
    height: '100%',

    [theme.breakpoints.down('md')]: {
      display: 'none',
    },
  },

  infoName: {},

  controlWrapper: {
    display: 'flex',
    gap: '8px',
    flexWrap: 'wrap',
    //justifyContent: 'flex-end',
  },

  userWrapperAdjacent: {
    marginTop: '8px',
  },
}));
